import { constants } from 'js-utils/datetime';

// reexport from js-utils to avoid breaking contract
export const { ISO_8601_DATE_FORMAT } = constants;

// formats based on the locale (ie en_US = MM/DD/YYYY)
export const DEFAULT_INPUT_DISPLAY_FORMAT = 'L';
